var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbnail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 350,
    viewBox: "0 0 350 350",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 350,
    height: 350,
    fill: "#F4F4F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M127 144.188C127 137.5 132.437 132.062 139.125 132.062H211.875C218.563 132.062 224 137.5 224 144.188V204.812C224 211.5 218.563 216.938 211.875 216.938H139.125C132.437 216.938 127 211.5 127 204.812V144.188ZM188.345 164.364C187.492 163.114 186.09 162.375 184.594 162.375C183.097 162.375 181.676 163.114 180.843 164.364L164.36 188.538L159.34 182.268C158.468 181.188 157.161 180.562 155.797 180.562C154.433 180.562 153.107 181.188 152.254 182.268L140.129 197.424C139.03 198.788 138.822 200.663 139.58 202.236C140.338 203.808 141.929 204.812 143.672 204.812H161.859H167.922H207.328C209.014 204.812 210.568 203.884 211.345 202.388C212.121 200.891 212.027 199.091 211.079 197.708L188.345 164.364ZM148.219 162.375C150.631 162.375 152.944 161.417 154.649 159.712C156.354 158.006 157.312 155.693 157.312 153.281C157.312 150.869 156.354 148.556 154.649 146.851C152.944 145.146 150.631 144.188 148.219 144.188C145.807 144.188 143.494 145.146 141.788 146.851C140.083 148.556 139.125 150.869 139.125 153.281C139.125 155.693 140.083 158.006 141.788 159.712C143.494 161.417 145.807 162.375 148.219 162.375Z",
    fill: "#2F8DE4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbnail);
export default __webpack_public_path__ + "static/media/thumbnail.2c8389ebeee0bac26c8f21119ea3aab0.svg";
export { ForwardRef as ReactComponent };